const DEFAULT_ENTROPY = 150;
let ENTROPY = DEFAULT_ENTROPY;

export function getEntropy(): number {
    return ENTROPY;
}

/**
 * When running unit tests, we may want predictable orderIndexes.
 * In that case, we can set the entropy to a 0 fixed value.
 */
export function disableOrderIndexEntropy() {
    if (process.env.NODE_ENV !== 'generate-data' && process.env.NODE_ENV !== 'test') {
        throw new Error(
            'disableOrderIndexEntropy() should only be called when generating local data'
        );
    }

    ENTROPY = 0;
}

/**
 * Reset the entropy to the default value.
 */
export function resetOrderIndexEntropy() {
    if (process.env.NODE_ENV !== 'generate-data' && process.env.NODE_ENV !== 'test') {
        throw new Error(
            'resetOrderIndexEntropy() should only be called when generating local data'
        );
    }

    ENTROPY = DEFAULT_ENTROPY;
}
